import { GetStaticPaths, GetStaticProps, NextPage } from 'next';
import React from 'react';
import { useIntl } from 'react-intl';

import socialMediaThumbnailUrl from '@/assets/raf/referee-landing-social-media-thumbnail.jpg';
import { RefereeLanding } from '@/components/route/invite/RefereeLanding';
import HeadMeta from '@/components/static-pages/HeadMeta';
import apiRequest from '@/services/apiRequest';
import { getCoreApi } from '@/utility/getCoreApi';
import { getParamAsString } from '@/utility/queryParams';

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  try {
    const code = decodeURIComponent(getParamAsString(params?.code) || '');

    const info = await apiRequest<{ name: string }>(
      { url: `${getCoreApi()}/referrals/${encodeURIComponent(code)}/info` },
      true,
    );

    if (!info.name) {
      return {
        notFound: true,
        revalidate: true,
      };
    }

    return {
      props: {
        code,
        referee: info.name,
      },
      revalidate: 3600,
    };
  } catch {
    return {
      notFound: true,
      revalidate: true,
    };
  }
};

type TRefereeLandingPageProps = {
  code: string;
  referee: string;
};

const RefereeLandingPage: NextPage<TRefereeLandingPageProps> = props => {
  const intl = useIntl();

  return (
    <>
      <HeadMeta
        title={intl.formatMessage({
          defaultMessage: 'Get $50 off your next Outdoorsy trip',
          id: 'DZtdUP',
        })}
        thumbnailURL={socialMediaThumbnailUrl}
        noindex
      />

      <RefereeLanding code={props.code} referee={props.referee} />
    </>
  );
};

export default RefereeLandingPage;
